module.exports = __webpack_public_path__ + "img/emoji-magnifying-glass-240x240.2f38336e.png";